











































































import { Vue, Component, Prop } from 'vue-property-decorator';
import * as mdi from '@mdi/js';
import * as primeicons from 'primeicons/primeicons.css';

@Component
export default class AxCardFieldIcon extends Vue {
  mdi = mdi;
  primeicons = primeicons;
  @Prop({ type: Boolean, default: false })
  full!: boolean;

  @Prop({ type: String, default: '' })
  label!: string;

  @Prop({ type: String, default: '50' })
  labelWidth!: string;

  @Prop({ type: String, default: '' })
  basis!: string;

  @Prop({ type: String })
  icon!: string;

  @Prop({ type: Boolean })
  small!: boolean;

  @Prop({ type: String })
  rightIcon!: string;

  @Prop({ type: Boolean, default: false })
  collapse!: boolean;

  get classVal() {
    const arr = [];
    if (this.small) arr.push('small');
    if (!this.icon) arr.push('no-icon');
    if (this.collapse) arr.push('collapse');
    return arr;
  }

  // @Prop({ type: Number, default: 15 })
  // fontSize!: number;

  get basisVal() {
    const flexBasis = this.full ? '100%' : this.basis;
    if (flexBasis) {
      return `flex-basis: ${flexBasis};`;
    }
    return '';
  }
}
